import React from 'react';
import { fetchTerms } from '../../services/academic';
import { Link } from 'react-router-dom';
import withCards from 'hoc/withCards';
import TermList from 'components/term/TermList';

const TermListPage = ({ ...props }) => {
  return (
    <>
      <div className="mb-3">
        <Link className="btn btn-primary" to={'etapas/new'}>
          CADASTRAR ETAPA
        </Link>
      </div>
      <TermList {...props} />
    </>
  );
};

export default withCards({
  fetch: fetchTerms,
  title: 'Lista de Etapas',
  paginated: true,
  noResultsText: 'Nenhuma etapa foi encontrada.',
})(TermListPage);
